/*
 * @Author: lzh
 * @Date: 2021-07-30 09:54:04
 * @LastEditors: lbh
 * @LastEditTime: 2024-05-28 10:05:08
 * @Description: file content
 */
import axios from "./http";

let origin = location.origin;
if (origin.indexOf("gingersoft.com") > -1) {
  origin = "https://m.ricepon.com";
}

let baseUrl = origin + "/member-web/api";
let restaurantUrl = origin + "/ricepon-restaurant/api";
let riceponMember = origin + "/ricepon-member/api";
let riceponSystem = origin + "/ricepon-system/api";
// 登錄
// export const loginOth = params => axios.post(baseUrl + '/system/loginOth', params);
// 新 登錄
export const loginOth = params =>
  axios.post(riceponMember + "/public/login", params);
// 註冊或修改密碼
// export const registerOth = params => axios.post(baseUrl + '/system/registerOth', params);

// 註冊或修改密碼
export const registerOth = params =>
  axios.post(baseUrl + "/member/registerOth", params);

// // 註冊 新接口  /api/member/registerOth
// export const register = params => axios.post(riceponMember + '/member/register', params);

// 校驗驗證碼
export const checkSmsCode = params =>
  axios.get(riceponSystem + "/public/sms/checkSmsCode", params);

// 發送驗證碼
export const sendSms = params =>
  axios.post(baseUrl + "/system/sendSms", params);

// 發送驗證碼  新
export const send = params =>
  axios.post(riceponSystem + "/public/sms/send", params);

// 獲取註冊協議
export const getResourceInfo = params =>
  axios.post(baseUrl + "/system/getResourceInfo", params);
// 校驗驗證碼
export const forgetPassword = params =>
  axios.post(baseUrl + "/system/forgetPassword", params);
// 重置密碼
// export const setPassword = params =>
//   axios.post(baseUrl + "/system/setPassword", params);

/**
 * 修改密碼
 * @param {*} params
 * @returns
 */
export const setPassword = params =>
  axios.post(riceponMember + "/memberInfo/update/password", params);

// 找回密碼
export const setPassword2 = params =>
  axios.post(riceponMember + "/public/set/password", params);

// 加入品牌接口
export const joinBrand = params =>
  axios.post(baseUrl + "/member/joinBrand", params);
// 修改個人資料
export const updateMemberInfo = params =>
  axios.post(baseUrl + "/member/updateMemberInfo", params);
// 查詢會員卡信息
export const getMemberInfoOth = params =>
  axios.post(baseUrl + "/member/getMemberInfoOth1", params);
// 查詢積分換取禮品
export const getProductInfoByBrandId = params =>
  axios.post(baseUrl + "/product/getProductInfoByBrandId", params);
// 查詢積分禮品詳情
export const getProductInfoById = params =>
  axios.post(baseUrl + "/product/getProductInfoById", params);
// 積分兌換禮品接口
export const exchange = params =>
  axios.post(baseUrl + "/product/exchange", params);
// 獲取餐廳列表
export const getRestaurantNew = params =>
  axios.post(baseUrl + "/restaurant/getRestaurantNew", params);
// 獲取餐廳列表_v2
export const getRestaurantNew_v2 = params =>
  axios.get(baseUrl + "/member/restaurant/getRestaurantNew/v2", params);
// 獲取餐廳詳情
export const getRestaurantInfoById = params =>
  axios.post(baseUrl + "/restaurant/getRestaurantInfoById", params);
// 获取积分记录
export const pointDetails = params =>
  axios.post(baseUrl + "/member/pointDetails", params);
// 獲取優惠券
// export const getMemberCoupon = params => axios.post(baseUrl + '/member/getMemberCoupon', params)
/**
 * 查詢 用戶 優惠券
 * @param {brandId,memberId,pageIndex=1,pageSize=10,type=2} params
 * @returns
 */
export const getMemberCoupon = params =>
  axios.post(`${riceponMember}/member/getMemberCoupon/v2`, params);
// 修改手機號
export const updateMemberPhone = params =>
  axios.post(baseUrl + "/member/updateMemberPhone", params);
// 修改手機號 新
export const updateMemberPhoneNew = params =>
  axios.post(riceponMember + "/member/update/phone", params);
// 二維碼
export const getQuickMark = params =>
  axios.post(baseUrl + "/member/quickMark", params);
// 根據品牌id查詢品牌名稱
export const getBandName = params =>
  axios.get(baseUrl + "/member/getBandName", params);
// 查詢訂座相關信息
export const getMaxSize = params =>
  axios.get(baseUrl + "/book/getMaxSize", params);
// 查詢訂座時間
export const getBookTime = params =>
  axios.get(baseUrl + "/book/getBookTime", params);
// 生成訂座信息
export const doBookings = params =>
  axios.get(baseUrl + "/book/doBookings", params);
// 查詢訂座列表
export const getAllBookings = params =>
  axios.post(baseUrl + "/book/getAllBookings", params);
// 删除订座记录
export const deleteBooks = params =>
  axios.post(baseUrl + "/book/deleteBooks", params);
//  查詢訂座歷史記錄 -- new
export const getAllBookings2 = params =>
  axios.post(baseUrl + "/book/getAllBookings2", params);
// 查詢品牌信息
export const getBrandByAlias = params =>
  axios.get(restaurantUrl + "/brand/getBrandByAlias", params);

/**
 * 獲取用戶的 推薦碼
 * @param {brandId,memberId} params
 * @returns
 */
export const getInvitationByMemberIdAndBrandId = params =>
  axios.get(`${riceponMember}/memberInvitationCodeLog/getByMemberId`, params);

/**
 * 校驗推薦碼是否存在
 * @param {brandId,invitationCode} params
 * @returns
 */
export const checkInvitationCode = params =>
  axios.get(
    `${riceponMember}/memberInvitationCode/checkInvitationCode`,
    params
  );

/**
 * 用戶 已讀 領券信息
 * @param {brandId,invitedMemberId 被邀請人會員id,isRead 0 未讀 1 已讀} params
 * @returns
 */
export const updateCodeIsRead = params =>
  axios.post(`${riceponMember}/memberInvitationCodeLog/updateIsRead`, params);

/**
 * 查詢 品牌下的  邀請券
 * @param {brandId} params
 * @returns
 */
export const getInvitationCoupon = params =>
  axios.get(
    `${riceponMember}/memberInvitationCodeLog/getInvitationCoupon`,
    params
  );

/**
 * 查詢 用戶 是否有被邀請的券 未讀
 * @param {brandId,invitedMemberId} params
 * @returns
 */
export const getByInvitedMemberIdOrBrandId = params =>
  axios.get(
    `${riceponMember}/memberInvitationCodeLog/getByInvitedMemberIdOrBrandId`,
    params
  );

/**
 * 獲取交易驗證碼
 * @param {memberId,brandId} params
 * @returns
 */
export const getTransactionVerificationCode = params =>
  axios.get(`${riceponMember}/member/getTransactionVerificationCode`, params);
// 獲取 區域列表, 沒有參數
export const getCountry = params =>
  axios.get(riceponSystem + "/public/country/list", params);

// 新 註冊
export const registerOthNew = params =>
  axios.post(riceponMember + "/public/register", params);

// 短信登錄
export const smsLogin = params =>
  axios.post(riceponMember + "/public/sms/login", params);

// 修改用戶信息
export const updataOth = params =>
  axios.body(riceponMember + "/memberInfo/update", params);

//  修改工作地址, 居住地址 , 年齡段
export const updateInfo = params =>
  axios.body(riceponMember + "/memberFoodStoryInfo/update", params);

/**
 * 掃碼兌換積分
 * @param {*} params
 * @returns
 */
export const bindEncashQRcode = params =>
  axios.post(`${baseUrl}/scan/bindEncashQRcode`, params);

export const getBrandConfigList = params =>
  axios.get(restaurantUrl + "/brandConfig/brand/getBrandConfigList", params);



// WEBPACK FOOTER //
// ./src/js/api.js